import { render, staticRenderFns } from "./clienteHome.vue?vue&type=template&id=0d6ee014&"
import script from "./clienteHome.vue?vue&type=script&lang=js&"
export * from "./clienteHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports